// extracted by mini-css-extract-plugin
export default {"note":"styles_note__KcSoC","buttons":"styles_buttons__6aZEW","button":"styles_button__LhMQG","cancelButton":"styles_cancelButton__guArP"};